module.exports = __webpack_public_path__ + "static/media/pool-light-gray.a284f92c.svg";